import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AdminService } from '../../../../../services/administrator/admin.service';
import { IDoaCategory } from '../../../../../interface/administrator/admin';
import { MaterialModule } from '../../../../../shared/module/material.module';
import { SharedServices } from '../../../../../shared/services/shared.services';
@Component({
  selector: 'app-add-update-dialog',
  imports: [CommonModule,MaterialModule,ReactiveFormsModule],
  templateUrl: './add-update-dialog.component.html',
  styleUrl: './add-update-dialog.component.css'
})
export class AddUpdateDialogComponent {
  DoaSubCategoryForm: FormGroup;
  isDeveloper:boolean=false;
  isLoading: boolean = false;
  dataSource:IDoaCategory[]=[];
  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddUpdateDialogComponent>,
    private http: HttpClient,
    private adminService: AdminService,
    private sharedService:SharedServices
  )

   {
    this.DoaSubCategoryForm = this.fb.group({
      id: [data.user?.id || null],
      subCatCode: [{value : data.user?.subCatCode || '',disabled: data.isEdit},[Validators.required, Validators.maxLength(3)]],
      subCatName: [data.user?.subCatName || '',[Validators.required, Validators.maxLength(500)]],
      catCode: [data.user?.catCode || '',Validators.required],
      subCatNote: [data.user?.subCatNote || '', [Validators.maxLength(1)]]
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.getDoaCategory();
      if (this.data.isEdit) {
        this.DoaSubCategoryForm.patchValue(this.data.user);
        this.data.initialValues = this.DoaSubCategoryForm.getRawValue();
      }
  }
  getDoaCategory(): void {
      this.adminService.getDoaCategory()
        .subscribe((data: IDoaCategory[]) => {
          this.dataSource = data;
        }, error => {
          console.error('Error fetching categories', error);
        });
    
  }

  onSave(): void {
    this.isLoading = true;
    if (this.DoaSubCategoryForm.invalid) {
      this.sharedService.openModal('Message', 'Please enter all required information');
      this.isLoading = false;
      return;
    }

    const subCatCode = this.DoaSubCategoryForm.get('subCatCode')?.value;
    const subCategoryExists = this.data.existingSubCategories.some((subCat: any) => subCat.subCatCode === subCatCode);
  
    if (!this.data.isEdit && subCategoryExists) {
      this.sharedService.openModal('Message', 'Sub-category code already exists');
      this.isLoading = false;
    } else {
      if (this.data.isEdit) {
        const updatedSubCategory = this.DoaSubCategoryForm.getRawValue();
        if (JSON.stringify(this.data.initialValues) === JSON.stringify(updatedSubCategory)) {
          this.sharedService.openModal('Message', 'No changes detected');
          this.isLoading = false;
          return;
        }
        this.adminService.updateDoaSubCategory(updatedSubCategory).subscribe({
          next: response => {
            this.dialogRef.close(response);
            this.isLoading = false;
            this.sharedService.openModal('Message', 'Updated Successfully');
          },
          error: error => {
            console.error('Error updating sub-category', error);
            this.isLoading = false;
          }
        });
      } else {
        this.adminService.addDoaSubCategory(this.DoaSubCategoryForm.value).subscribe({
          next: response => {
            this.dialogRef.close(true);
            this.isLoading = false;
            this.sharedService.openModal('Message', 'Added Successfully');
          },
          error: error => {
            console.error('Error adding sub-category', error);
            this.isLoading = false;
          }
        });
      }
    }
  }
}
